import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Workspace_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_WORKSPACE_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    WORKSPACE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    WORKSPACE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WORKSPACE_TYPE_ID:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type ID', columnResourceName: 'colTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_AUTHUSR_ID:      {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB User Id',         columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    AUTHUSR_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Auth User Name', columnResourceName: 'colAuthUserName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    TREE_PATH:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Path',          columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const WorkspaceSearchProviderBasic: ISearchProvider = {

  keyFields: {id:    'WB_WORKSPACE_ID',
              id_ui: 'WORKSPACE_ID',
              name:  'WORKSPACE_NAME'},

  searchProviderFields: vUI_Workspace_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Workspace_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const WorkspaceSearchProfileByName: ISearchProfile = {
  profileId: "default",
  profileName: "By Id, Name",
  renderOptions: { ui5ResourceId: "WorkspaceSearchProfileByName" },

  profileFilter: [
    {profileFilterName: 'Id',     searchProviderFieldId: 'WORKSPACE_ID',   renderOptions: { }},
    {profileFilterName: 'Name',   searchProviderFieldId: 'WORKSPACE_NAME', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'WORKSPACE_NAME','WORKSPACE_ID', 'AUTHUSR_NAME','WORKSPACE_TYPE_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: WorkspaceSearchProviderBasic,

  profileTreeIdDefault: "default",
  profileTrees: [
    {treeId: "default",
      treeName: "By Hierarchy",
      nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
  ],

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}


const WorkspaceSearch: ISearch = {
  searchName: "Find Workspace",
  renderOptions: { ui5ResourceId: "WorkspaceSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: [WorkspaceSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("WorkspaceBO", "Workspace", WorkspaceSearch, "Workspace Search")

export {WorkspaceSearch}
